import { useLocation } from "react-router-dom";

import Tooltip from '@mui/joy/Tooltip';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import { ColorPaletteProp } from '@mui/joy';


import { SidebarLink } from 'components/Sidebar';

import useSidebar from "hooks/useSidebar";
import useRoles from "hooks/useRoles";
import getIcon from 'utils/getIcon';
import { capitalize } from 'utils/misc';

export default function IconLink({url, icon, title, tooltip, tooltipPlacement, role=""}: {url: string, icon: string, title: string, tooltip?: string, tooltipPlacement?: 'bottom-end' | 'right', role?: string}) {
    const { showingRegularSidebar } = useSidebar();
    const Icon = getIcon(icon);
    const location = useLocation();
    const selected = location.pathname.endsWith(url);
    const { hasRole } = useRoles();
    if(role && !hasRole(role)) {
        return null;
    }

    let color = undefined;
    let iconColor = undefined;
    if(role == 'sudo') {
        color = 'danger';
        // iconColor = 'primary';
    }
    else if(role =='manager') {
        color = 'warning';
        //iconColor = 'warning';
    }
    else if (role == 'support') {
        color = 'success';
        iconColor = 'success';
    }

    let tt = tooltip || title;
    if(role) tt += ` (${capitalize(role)} team only)`;
    return (
        <SidebarLink to={url}>
            <Tooltip
                placement={!showingRegularSidebar ? 'bottom' : (tooltipPlacement || 'right')}
                title={tt}
                arrow>
                <ListItem>
                    <ListItemButton
                        variant={selected ? "soft" : undefined}
                        color={selected ? color as ColorPaletteProp : undefined}
                    >
                        <ListItemDecorator>
                            <Icon color={iconColor} />
                        </ListItemDecorator>
                        {title}
                    </ListItemButton>
                </ListItem>
            </Tooltip>
        </SidebarLink>
    );
}
